import React from 'react';
import { Row, Col, Typography, Form, Input, Button } from 'antd';
import { FormikProps } from 'formik';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import {
  logo,
  logoLinkTic,
  bgLogin,
  logoBienes,
  logoLeonix,
} from '../../../../assets/logos';

const { Title, Text } = Typography;

interface AuthViewProps {
  formik: FormikProps<{ email: string; password: string }>;
}

const AuthView: React.FC<AuthViewProps> = ({ formik }) => {
  return (
    <div className="background-auth">
      <Row
        className="container-img"
        style={{
          minHeight: '100vh',
          backgroundImage: `url(${bgLogin})`,
        }}
      >
        <Col xs={24} md={12} className="auth-right container-auth">
          <div className="auth-form-container">
            <div className="auth-header">
              <img
                src={logoLinkTic}
                alt="Leonix"
                className="auth-logo-fiscalia mt-2"
                width={350}
                height={120}
              />
              <img
                src={logoLeonix}
                alt="Leonix"
                className="auth-logo-bienes"
                width={400}
              />
            </div>

            <div className="container-form">
              <Title className="auth-title">Bienvenido al portal web</Title>
              <Text type="secondary" className="auth-subtitle">
                Ingrese los datos para continuar
              </Text>

              <Form
                layout="vertical"
                onFinish={formik.handleSubmit}
                className="auth-form"
              >
                <Form.Item
                  label="Usuario"
                  validateStatus={
                    formik.errors.email && formik.touched.email ? 'error' : ''
                  }
                  help={formik.touched.email && formik.errors.email}
                >
                  <Input
                    name="email"
                    placeholder="Ingrese su usuario"
                    prefix={<UserOutlined />}
                    size="large"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Form.Item>

                <Form.Item
                  label="Contraseña"
                  validateStatus={
                    formik.errors.password && formik.touched.password
                      ? 'error'
                      : ''
                  }
                  help={formik.touched.password && formik.errors.password}
                >
                  <Input.Password
                    name="password"
                    placeholder="**********"
                    prefix={<LockOutlined />}
                    size="large"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    loading={formik.isSubmitting}
                  >
                    Ingresar
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AuthView;
